"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var padding = {
  large: '19px 32px',
  small: '5px 14px'
};
var fontSize = {
  fontSizeLarge: '18px',
  fontSizeSmall: '14px'
};
var outlineStyles = {
  outlineStylesPaddingMedium: '13px 14px',
  outlineStylesLetterSpacing: '0'
};
var buttonOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, outlineStyles), padding), fontSize), {}, {
  letterSpacingSmall: '0.2px',
  fontWeight: 600
});
var _default = exports.default = buttonOptions;